import MDAlert from "components/MDAlert";
import MDTypography from "components/MDTypography";
import DataTable from "components/Tables/DataTable/DataTable";
import TableSkeleton from "components/TableSkeleton/TableSkeleton";
import useArchivedEmployeesTable from "hooks/organization/employees/useArchivedEmployeesTable";

export default function ListArchivedEmployees() {
  const { loading, error, data, tableData, pagination, filtering } = useArchivedEmployeesTable();

  return (
    <>
      {(loading || error) && (
        <div style={{ padding: "16px" }}>
          {loading && <TableSkeleton numberOfLines={pagination.pageSize} />}
          {error && <MDAlert color="error">{error.message}</MDAlert>}
        </div>
      )}
      {!loading && !error && data && data.length === 0 && (
        <MDTypography variant="body2" color="text" sx={{ p: 3, textAlign: "center" }}>
          No archived employees
        </MDTypography>
      )}
      {!loading && !error && data && data.length > 0 && (
        <DataTable table={tableData} canSearch pagination={pagination} filtering={filtering} />
      )}
    </>
  );
}
